module.exports = __webpack_public_path__ + "img/Flow_KOVAX@3x.baa658a5.png";